import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.test';

@Injectable()
export class ContactosUsersService {
  private resourceUrl = `${environment.API_URL}/contactos-users`;

  constructor(private http: HttpClient) {}

  getAllCurrent(): Observable<any> {
    return this.http.get(`${this.resourceUrl}/current`, {
      observe: 'response',
    });
  }

  saveCurrent(params: any): Observable<any> {
    return this.http.post(`${this.resourceUrl}/current`, params, {
      observe: 'response',
    });
  }

  getByPropietarioAndContacto(
    propietarioId: number,
    contactoId: number,
  ): Observable<any> {
    return this.http.get(
      this.resourceUrl +
        '/by-propietario/by-contacto/' +
        propietarioId +
        '/' +
        contactoId,
      { observe: 'response' },
    );
  }

  groupByUserCurrent(): Observable<any> {
    return this.http.get(`${this.resourceUrl}/group-by-letra/by-user/current`, {
      observe: 'response',
    });
  }
}
